import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarsRoutingModule } from './mars-routing.module';
import { CoreModule } from 'core/core.module';
import { MarsTutorizationModule } from 'app/mars-tutorization/mars-tutorization.module';
import { MarsGroupService } from './services/mars-groups.service';
import { MarsGroupActivityComponent } from './components/mars-group/mars-group-activity/mars-group-activity.component';
import { MarsGroupListComponent } from './components/mars-group-list/mars-group-list.component';
import { MarsGroupsComponent } from './components/mars-groups/mars-groups.component';
import { MarsGroupComponent } from './components/mars-group/mars-group.component';
import { MarsGroupConfigComponent } from './components/mars-group/mars-group-config/mars-group-config.component';
import { MarsGroupSurveysComponent } from './components/mars-group/mars-group-surveys/mars-group-surveys.component';
import { MarsGroupTutorizationComponent } from './components/mars-group/mars-group-tutorization/mars-group-tutorization.component';
import { MarsGroupDataComponent } from './components/mars-group/mars-group-data/mars-group-data.component';
import { MarsGroupLicenseComponent } from './components/mars-group/mars-group-license/mars-group-license.component';
import { MarsLicenseProgressListComponent } from './components/mars-group/mars-group-license/mars-license-progress-list/mars-license-progress-list.component';
import { MarsLicenseEditorComponent } from './components/mars-group/mars-group-license/mars-license-editor/mars-license-editor.component';
import { MarsLicenseService } from './services/mars-licenses.service';
import { MarsGroupNotificationComponent } from './components/mars-group/mars-group-notification/mars-group-notification.component';
import { WidgetModule } from '../widget';
import { EmailsModule } from 'app/emails/emails.module';

@NgModule({
  declarations: [
    MarsGroupListComponent,
    MarsGroupsComponent,
    MarsGroupComponent,
    MarsGroupActivityComponent,
    MarsGroupConfigComponent,
    MarsGroupDataComponent,
    MarsGroupSurveysComponent,
    MarsGroupTutorizationComponent,
    MarsGroupLicenseComponent,
    MarsLicenseProgressListComponent,
    MarsLicenseEditorComponent,
    MarsGroupNotificationComponent
  ],
  imports: [CommonModule, MarsRoutingModule, CoreModule, MarsTutorizationModule, WidgetModule, EmailsModule],
  providers: [MarsGroupService, MarsLicenseService],
  exports: [MarsGroupListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarsModule {}
